import { IPaginationPortalPayload } from "./paginationResponse.types";

export interface Facility {
  id: number;
  name: string;
  facilityKind: FacilityKind;
  country: string;
  city: string;
  zipCode: string;
  street: string;
  active: boolean;
  selected: boolean;
  defaultFacility: boolean;
}

export interface IWarehousesResponse {
  nearestFacilities: Facility[];
  recentFacilities: Facility[];
}

export enum FacilityKind {
  FM = "FM",
  RCL = "RCL",
  BTH = "BTH",
  FILIA = "FILIA",
}

interface IOpeningHours {
  days: string;
  hours: string;
}

export interface IWarehouse {
  id: number;
  externalId: string;
  code: string;
  name: string;
  street: string;
  streetNumber: string;
  flatNumber: string;
  city: string;
  zipCode: string;
  distanceToRequestedLocalization: string;
  voivodeship: string;
  country: string;
  clickAndCollect: string;
  floor: string;
  clickAndCollectPrice: number;
  geoLatitude: string;
  geoLongitude: string;
  openingHours: IOpeningHours[];
  phone: string;
  webPageUrl: string;
  email: string;
  photoLocation: string;
  facilityKind: FacilityKind;
  active: boolean;
  archive: boolean;
}

export interface IAllWarehousesResponse {
  result: IWarehouse[];
}

export interface IWarehousesRequest extends IPaginationPortalPayload {
  searchPhrase?: string | null;
  cartStatus?: boolean;
  visibleInLocator?: boolean;
  useGeolocation?: boolean;
  filteredKinds?: FacilityKind[] | null;
  facilities?: number[];
}
